import { CONFIG } from 'config/config';

import styled from 'styled-components/macro';

export const InputLabelWrapper = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	justify-content: space-between;
	width: 100%;
`;

export const InputWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

	width: ${(props) => {
		if (!props.mountExtraSpace) {
			return '100%';
		} else {
			return '85%';
		}
	}};
`;

export const PasswordInputWrapper = styled.div`
	display: flex;
	align-items: center;
	max-width: ${CONFIG.inputs.maxWidth.default};
`;

export const CurrencyInputWrapper = styled.div`
	max-width: ${CONFIG.inputs.maxWidth.default};
	color: ${CONFIG.inputs.color};
	font-family: ${CONFIG.inputs.fontFamily};
	font-size: ${CONFIG.inputs.fontSize};
	padding: ${CONFIG.inputs.padding.currency};

	border: ${(props) => {
		if (!props.value) {
			return CONFIG.inputs.border.default;
		} else {
			return CONFIG.inputs.border.filled;
		}
	}};
	border-radius: ${CONFIG.inputs.border.radius};

	display: flex;
	justify-content: flex-start;
	align-items: center;

	transition: 0.2s all;
	&:focus-within {
		border-bottom: ${CONFIG.inputs.focus.borderBottom.full};
	}
`;

export const SelectWrapper = styled.div`
	max-width: ${CONFIG.inputs.maxWidth.default};
	display: flex;
	flex-direction: row;
	align-items: center;

	.MuiSelect-select > p.inputSelectOptionsSt {
		max-width: calc(100% - 35px);
		overflow: hidden;
	}

	.MuiSelect-select {
		display: flex;
		align-items: center;
	}

	.MuiSelect-icon {
		top: calc(50% - 10px);
		height: auto;
		right: 20px;
	}

	.MuiInputBase-root {
		padding: ${CONFIG.inputs.padding.select};
		max-width: ${CONFIG.inputs.maxWidth.default};

		width: ${(props) => {
			if (!props.mountExtraSpace) {
				return '100%';
			} else {
				return '85%';
			}
		}};

		border: ${(props) => {
			if (!props.value) {
				return CONFIG.inputs.border.default;
			} else {
				return CONFIG.inputs.border.filled;
			}
		}};
		border-radius: ${CONFIG.inputs.border.radius};

		::placeholder {
			color: ${CONFIG.inputs.placeholder.color};
			font-family: ${CONFIG.inputs.placeholder.fontFamily};
			font-size: ${CONFIG.inputs.placeholder.fontSize};
		}

		transition: 0.2s all;
		&:focus {
			border-bottom: ${CONFIG.inputs.focus.borderBottom.full};
		}
	}
`;

export const DateWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

	width: ${(props) => {
		if (!props.mountExtraSpace) {
			return '100%';
		} else {
			return '85%';
		}
	}};

	.MuiFormControl-root {
		max-width: ${CONFIG.inputs.maxWidth.default};
		width: 100%;
	}

	.MuiFormControl-marginDense {
		margin: 0;
	}
`;

export const PasswordInputIcon = styled.div``;
